import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core';
import * as Types from 'pages/Features/typings';
import { CARD_CONTENT_CLASSIC_STYLE_KEY_ADVANCED } from 'pages/Features/constants';

import Typography from '@material-ui/core/Typography';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Tooltip from '@material-ui/core/Tooltip';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

interface Props {
  values: Types.FeatureValues;
  view: string;
  onChange: (field: string, value: any) => void;
}

function BasicInfo({ values, view, onChange }: Props) {
  const classes = useStyles();

  const basicOptions = [
    {
      displayName: 'Name',
      attrPath: `person.directory.orgChart.cardContent.${view}.basicInfo.name`,
    },
    {
      displayName: 'Profile Photo',
      attrPath: `person.directory.orgChart.cardContent.${view}.basicInfo.profilePicture`,
    },
    {
      displayName: 'Job Title',
      attrPath: `person.directory.orgChart.cardContent.${view}.basicInfo.title`,
    },
  ];

  const highlightValueAttrPath = `person.directory.orgChart.cardContent.${view}.basicInfo.highlightValue`;

  if (view === CARD_CONTENT_CLASSIC_STYLE_KEY_ADVANCED) {
    basicOptions.push({
      displayName: 'Email',
      attrPath: `person.directory.orgChart.cardContent.${view}.basicInfo.email`,
    });
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, attrPath: string) => {
    onChange(attrPath, event.target.checked);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h6">Basic Info</Typography>
      <div>
        {basicOptions.map((option, i) => {
          const { displayName, attrPath } = option;

          return (
            <div className={classes.item} key={`basic-info-option-${i}`}>
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    className={classes.switchMargin}
                    checked={_get(values, attrPath)}
                    onChange={e => handleChange(e, attrPath)}
                  />
                }
                label={<Typography variant="body2">{displayName}</Typography>}
              />
            </div>
          );
        })}

        <div className={classes.item}>
          <FormControlLabel
            control={
              <Switch
                size="small"
                className={classes.switchMargin}
                checked={_get(values, highlightValueAttrPath)}
                onChange={e => handleChange(e, highlightValueAttrPath)}
              />
            }
            label={
              <div className={classes.highlightByLabel}>
                <Typography variant="body2">Highlight Value</Typography>
                <Tooltip
                  title="When using the Highlight By feature, we will display the associated value on each card."
                  placement="top"
                  arrow
                >
                  <InfoOutlinedIcon className={classes.info} />
                </Tooltip>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 316,
    minHeight: 241,
    width: '100%',
    padding: theme.spacing(3),
  },
  info: {
    maxHeight: 16,
    maxWidth: 16,
    marginLeft: theme.spacing(0.5),
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    height: 41,
    marginLeft: theme.spacing(1.375),
  },
  highlightByLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  switchMargin: {
    marginRight: theme.spacing(2.25),
  },
}));

export default BasicInfo;
